import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import Cookies from 'js-cookie';
import { logout } from '../slices/authSlice';
import { openAuthModal } from '../slices/uiSlice';

const baseQuery = fetchBaseQuery({
  baseUrl: import.meta.env.VITE_API_BASE_URL || '/api',
  prepareHeaders: (headers) => {
    const token = Cookies.get('access-token');

    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    }
    return headers;
  },
});

const baseQueryWithReauth = async (args: any, api: any, extraOptions: any) => {
  // Only a request sent with a token can mean "your session expired"; a guest's 401 is ignored.
  // `logout()` removes the cookie, so the other requests of the same burst count as guest ones.
  const hadSession = Boolean(Cookies.get('access-token'));
  const result = await baseQuery(args, api, extraOptions);
  const url: string = typeof args === 'string' ? args : (args?.url ?? '');
  if (result.error && result.error.status === 401 && hadSession && !url.startsWith('/auth/')) {
    // Same as Sign Out, then the login popup returns the user to this page.
    api.dispatch(apiSlice.util.resetApiState());
    api.dispatch(logout());
    api.dispatch(
      openAuthModal({
        view: 'login',
        returnTo: `${window.location.pathname}${window.location.search}`,
      })
    );
  }
  return result;
};

export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['User', 'Auth', 'FeatureFlags', 'Sports', 'Bets', 'Account', 'Content', 'Support'],
  endpoints: () => ({}),
});

// Export hooks for usage in functional components
export const {
  util: { getRunningQueriesThunk },
} = apiSlice;
// Export the api slice for use in store
export default apiSlice;
